import { render, staticRenderFns } from "./workOrderPageAdmin.vue?vue&type=template&id=7ecfb7ae&scoped=true"
import script from "./workOrderPageAdmin.vue?vue&type=script&lang=js"
export * from "./workOrderPageAdmin.vue?vue&type=script&lang=js"
import style0 from "./workOrderPageAdmin.vue?vue&type=style&index=0&id=7ecfb7ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecfb7ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ecfb7ae')) {
      api.createRecord('7ecfb7ae', component.options)
    } else {
      api.reload('7ecfb7ae', component.options)
    }
    module.hot.accept("./workOrderPageAdmin.vue?vue&type=template&id=7ecfb7ae&scoped=true", function () {
      api.rerender('7ecfb7ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/workorder/components/workOrderPageAdmin.vue"
export default component.exports